










































import { Component, Vue } from 'vue-property-decorator';
import axios from 'axios';

@Component
export default class TermsModal extends Vue {
  private main = '';

  async mounted() {
    const main = await axios.get(`${process.env.VUE_APP_BASE_URL}/static/term_main.html`)
      .then((response) => response.data);
    if (typeof main === 'string') {
      this.main = main.replace('{{VUE_APP_BASE_URL}}', process.env.VUE_APP_BASE_URL as string);
    }
  }

  get displayFlg() {
    return this.$store.state.isDisplayTermsModal;
  }

  modalClose() {
    this.$store.commit('displayTermsModal', false);
  }
}
